import { cva, type VariantProps } from 'class-variance-authority';

export const buttonVariants = cva(
	'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-all duration-200 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
	{
		variants: {
			variant: {
				default:
					'bg-cta text-cta-foreground shadow-sm hover:opacity-90 active:opacity-80',
				secondary:
					'bg-muted text-foreground hover:bg-muted/70 active:brightness-[0.97]',
				destructive:
					'bg-destructive text-destructive-foreground shadow-sm hover:brightness-95 active:brightness-90',
				outline:
					'border border-border bg-transparent text-foreground hover:bg-muted/60',
				ghost:
					'hover:bg-muted/60 hover:text-foreground',
				link:
					'text-foreground underline-offset-4 hover:underline',
				hero:
					'bg-foreground text-background shadow-md hover:opacity-90 active:opacity-80',
				heroSecondary:
					'bg-muted text-foreground hover:bg-muted/70',
				vet:
					'bg-[--vet] text-[--vet-deep] shadow-sm hover:brightness-95 active:brightness-90',
				grooming:
					'bg-[--groom] text-[--groom-deep] shadow-sm hover:brightness-95 active:brightness-90',
				onlineVet:
					'bg-[--teal] text-[--teal-deep] shadow-sm hover:brightness-95 active:brightness-90',
				success:
					'bg-success text-success-foreground shadow-sm hover:brightness-95',
				featured:
					'bg-[--groom] text-[--groom-deep] shadow-sm hover:brightness-95 active:brightness-90',
			},
			size: {
				default: 'h-10 px-5 py-2',
				sm: 'h-9 px-4 text-xs',
				lg: 'h-12 px-8 text-base font-semibold',
				xl: 'h-14 px-10 text-base font-semibold',
				icon: 'h-10 w-10',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	},
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
